import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function NotificationsReducer(state = initialState.notification, action) 
{
  if (action.type === types.NOTIFICATION_DEBUG ||
    action.type === types.NOTIFICATION_ERROR ||
    action.type === types.NOTIFICATION_INFO ||
    action.type === types.NOTIFICATION_SUCCESS ||
    action.type === types.NOTIFICATION_WARNING ||
    action.type === types.CLEAR_NOTIFICATIONS) 
  {
    // A clear is stored like any other notification - Notifications acts on it and
    // then leaves it alone. Resetting to null instead would make every clear look
    // identical to the initial state, and the next one would go unnoticed.
    return action.notification;
  }
  return state;
}
